import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import moment from 'moment'
import template from './home-alerts.hbs'
import AlertList from './alert-list'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import alerts from 'scoreboard/components/alerts'
import user from 'scoreboard/components/user'
import alertHelper from 'scoreboard/alerts/alert-helper'
import Tooltip from 'scoreboard/components/tooltip'
import DeleteConfirmationTooltip from 'scoreboard/components/delete-confirmation-tooltip'
import HomeNav from '../home-nav'
import { isV5, isV6 } from 'scoreboard/components/version'
import NotificationPreferences from 'scoreboard/admin/alerts/notification-preferences'
import AlertSubscriptionsEditor from './alert-subscriptions-editor'
import appDisplay from 'scoreboard/components/app-display'

var MAX_HISTORY = 200

var HomeAlerts = Backbone.View.extend({

	// this.data is the data returned from GET api/alerts

	className: 'home alerts display-layout table-hack',

	events: {
		'click .mark-read': 'onMarkAllRead',
		'click .clear-history': 'clearHistory',
		'click .alert-triggers': 'onClickAlertTriggers'
	},

	initialize: function(options) {
		this.options = options || {}
		this.data = this.options.data
		alerts.listenForPushNotification(this, newData => {
			this.data = newData
			this.render()
		})
	},

	render: function() {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('common.alerts'),
			mobileGearHidden: true
		}).render().el, template(this.context()))

		var alertsData = alertHelper.dataByIdByDomainType(this.data)
		this.renderUnread(alertsData)
		this.renderRead(alertsData)
		if (isV6()) this.renderAlertSettings(alertsData)
		this._setupListeners()
		this._resizeAlertLists()
		this.secure()

		this.homeNav = new HomeNav({
			section: 'alerts'
		})
		this.$('.home-nav-container').append(this.homeNav.el)
		this.homeNav.render()

		return this
	},

	context: function() {
		if (isV5()) return {}

		const numAlertTriggers = _.size(this.data.subscriptions)
		const alertTriggersLabel = i18n.countMessage('home.alerts.alertTriggers',
			numAlertTriggers)
		return { alertTriggersLabel }
	},

	_setupListeners() {
		this.on('resize', () => this._resizeAlertLists())
	},

	_resizeAlertLists() {
		this.unreadList.adjustOverflow()
		this.readList.adjustOverflow()
	},

	renderAlertSettings: function() {
		const notificationPreferences = new NotificationPreferences(
			{ data: this.data })
		this.$('.alert-settings .panel-content').append(
			notificationPreferences.el)
		notificationPreferences.render()
	},

	onClickAlertTriggers: function() {
		const view = new AlertSubscriptionsEditor({ data: this.data })
		appDisplay.dialog(view)
		view.on('done', (subscriptions) => {
			this.data.subscriptions = subscriptions
			const newLabel = this.context().alertTriggersLabel
			this.$('.alert-triggers').html(newLabel)
		})
	},

	renderUnread(alertsData) {
		alertsData.unread = true
		_.invoke(this.unreadList, 'remove')
		this.unreadList = new AlertList({
			data: _.extend({ alerts: this.data.unread }, alertsData)
		})
		this.unreadList.on('change', this.onListChange.bind(this))
		this.$('.unread .alert-list').replaceWith(this.unreadList.el)
		this.unreadList.render()
		this.$('.unread-total').text(alerts.unreadAlerts)
		// hide "No New Alerts" message if appropriate
		this.toggleNoResultsMessage()
		if (_.size(this.data.unread) == 0) {
			this.$('.unread-total').hide()
		}
	},

	renderRead(alertsData) {
		_.invoke(this.readList, 'remove')
		this.readList = new AlertList({
			data: _.extend({ alerts: this.data.history }, alertsData)
		})
		this.readList.on('change', this.onListChange.bind(this))
		this.$('.history .alert-list').replaceWith(this.readList.el)
		this.readList.render()
		if (_.size(this.data.history) > 0) {
			// this total goes next to the "Show All" link at the bottom, which
			// isn't implemented yet
			//this.$('.history-total').text("(" + _.size(d.history) + ")")
		}
		// hide "No Alerts in History" message if appropriate
		this.toggleNoResultsMessage()

		/* The ability to show all alerts isn't coded yet
		if(historyTotal <= MAX_HISTORY) {
			this.$('.history .show-all-alerts').addClass('is-not-displayed')
		}
		*/
	},

	onMarkAllRead: function() {

		$.post('api/alerts/read') // don't wait for a response from the server

		// re-assign all to history, and mark them read so the right buttons show up
		this.data.history = (this.data.unread || []).concat(this.data.history || [])
		// #25076 set a value for "read" so the action buttons display properly
		// (since we don't have a timestamp from the server for this property yet)
		_.each(this.data.history, a => a.read = true)

		this.data.unread = null
		// just rendering again b/c i tried moving the DOM nodes and the
		// nth-child coloring of the rows wasn't fixed properly
		this.render()

		Backbone.trigger('change:unread', {numUnread:0})
	},

	clearHistory: function(event) {
		const message = i18n.get('common.delete.confirmation.message',
			i18n.get('home.alerts.allHistory'))

		this._confirmDelete(event, {message}, () => {
			$.post('api/alerts/clear-history')

			// #11383 in case we re-render, clear the history in memory
			this.data.history = []

			this.$('.history .alert-list').empty()
			this.$('.history .alert-list-empty').removeClass('is-not-displayed')
		})
	},

	/**
	 *
	 * @param {Number} id The alert id
	 * @param {jQuery} item The alert item for the action
	 * @param {String} action
	 */
	onListChange({event, id, item, action}) {

		if (action === 'delete') {
			this._confirmDelete(event, {label: i18n.get('common.alert')}, () => {
				this.deleteItemFromList(item, id)
				$.delete(`api/alerts/${id}`)
			})
		} else { // read|unread
			let source = 'unread'
			let target = 'history'
			if (action === 'unread') {
				source = 'history'
				target = 'unread'
			}
			if (!this.data[target]) {
				this.data[target] = []
			}
			this._moveAlert(this.data[source], this.data[target], id, item, action)
			this.toggleNoResultsMessage()
			// Inform the server
			$.post(`api/alerts/${action}/${id}`)
		}
		Backbone.trigger('change:unread', {numUnread: _.size(this.data.unread)})
	},

	_moveAlert: function (sourceDataList, targetDataList, id, item, action) {
		const alert = _.find(sourceDataList, {id: id})
		// Update state
		alert.read = action === 'unread' ? null : true
		_.remove(sourceDataList, {id})
		const insertAt = this._findInsertionPoint(targetDataList, alert)
		targetDataList.splice(insertAt, 0, alert)
		// And update the UI
		item.remove()
		this[`${action}List`].appendAt(insertAt, alert)
		this[`${action}List`].alertList = _.map(targetDataList, alert =>
			this[`${action}List`].createAlertContext(alert))
	},

	_findInsertionPoint: function (targetDataList, alert) {
		const foundAt = _.findIndex(targetDataList, a =>
			moment(alert.created).isSameOrAfter(moment(a.created)))

		return foundAt >= 0 ? foundAt : _.size(targetDataList)
	},

	_confirmDelete: function(event, tooltipOptions, onDelete) {
		_.invoke(this._deleteTooltip, 'remove')
		this._deleteTooltip = new DeleteConfirmationTooltip(tooltipOptions).render()
		this._tooltip = new Tooltip({
			content: this._deleteTooltip.el,
			attachTo: this.$(event.target),
			placement: 'below',
			arrow: 'center',
			extraClass: 'delete-confirmation-tooltip'
		}).render()
		this.listenTo(this._deleteTooltip, 'cancel delete', this._tooltip.remove.bind(this._tooltip))
		this.listenTo(this._deleteTooltip, 'delete', onDelete)
	},


	deleteItemFromList(item, id) {
		item.remove()
		// remove item from data so we have correct counts
		_.remove(this.data.history, {id: id})
		_.remove(this.data.unread, {id: id})
		// update no results message if appropriate
		this.toggleNoResultsMessage()
	},

	/**
	 * toggles the display of the no results message for the alert lists
	 */
	toggleNoResultsMessage: function() {
		let unreadAlerts = _.size(this.data.unread) > 0
		this.$('.unread .alert-list-empty').toggleClass('is-not-displayed', unreadAlerts)
		let historyAlerts = _.size(this.data.history) > 0
		this.$('.history .alert-list-empty').toggleClass('is-not-displayed', historyAlerts)
	},

	secure () {
		let editable = !user.isStrictViewer()
		// public read only users can't edit stuff though
		if (user.model.get('publicReadOnlyUser')) {
			editable = false
		}
		this.$('.edit-subscription-div').toggleClass('is-not-displayed', !editable)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		alerts.stopListeningForPushNotification(this)
	}
})

export default HomeAlerts

HomeAlerts.__filename__ = 'home/alerts/home-alerts.js'
